/**
 * Responsive Dropdown Navigation Handler
 *
 * Desktop: Hover-only dropdowns (no JavaScript)
 * Mobile/Offcanvas: inline collapse submenus (Bootstrap data attributes)
 */

document.addEventListener('DOMContentLoaded', function () {
    // Check if we're on desktop (>= 992px, matches the header-nav container's lg breakpoint)
    function isDesktop() {
        return window.innerWidth >= 992;
    }

    function hasBootstrapDropdowns() {
        return typeof window.bootstrap !== 'undefined' && window.bootstrap.Dropdown;
    }

    function hasBootstrapOffcanvas() {
        return typeof window.bootstrap !== 'undefined' && window.bootstrap.Offcanvas;
    }

    const headerNav = document.querySelector('.header-nav');
    if (!headerNav) {
        return;
    }

    // ============================================
    // DESKTOP ONLY: Disable Bootstrap dropdowns in header nav for CSS hover
    // ============================================
    function initializeDropdowns() {
        if (isDesktop()) {
            // Only target dropdowns in the main header nav menu, NOT in offcanvas
            const headerDropdowns = headerNav.querySelectorAll('.nav-menu .dropdown-toggle');

            headerDropdowns.forEach(function (toggle) {
                // Remove data-bs-toggle to prevent Bootstrap from hijacking clicks
                toggle.removeAttribute('data-bs-toggle');
                toggle.removeAttribute('aria-expanded');

                // Dispose of any existing Bootstrap dropdown instances
                if (hasBootstrapDropdowns()) {
                    const existingInstance = window.bootstrap.Dropdown.getInstance(toggle);
                    if (existingInstance) {
                        existingInstance.dispose();
                    }
                }
            });
        } else {
            // On mobile, ensure data-bs-toggle is present for Bootstrap behavior
            const headerDropdowns = headerNav.querySelectorAll('.nav-menu .dropdown-toggle');
            headerDropdowns.forEach(function (toggle) {
                if (!toggle.hasAttribute('data-bs-toggle')) {
                    toggle.setAttribute('data-bs-toggle', 'dropdown');
                }
            });
        }
    }

    // Initialize on page load
    initializeDropdowns();

    // Only re-initialize when crossing desktop/mobile threshold
    let wasDesktop = isDesktop();
    window.addEventListener('resize', function () {
        const nowDesktop = isDesktop();
        if (wasDesktop !== nowDesktop) {
            wasDesktop = nowDesktop;
            initializeDropdowns();
        }
    });

    // ============================================
    // OFFCANVAS FIX - Disable Bootstrap scroll lock and handle manually
    // ============================================
    const offcanvasElement = document.getElementById('offcanvasNav');
    if (offcanvasElement && hasBootstrapOffcanvas()) {
        let scrollY = 0;

        // Create offcanvas instance with scroll enabled (we'll handle it)
        const bsOffcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement, {
            scroll: true,  // Disable Bootstrap's scroll lock
            backdrop: true
        });

        offcanvasElement.addEventListener('show.bs.offcanvas', function () {
            // Save scroll position and lock scroll
            scrollY = window.pageYOffset;
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';

        });

        // Submenus are collapses, wired declaratively by Bootstrap. Scroll a
        // freshly opened one into view so its list isn't left below the fold.
        offcanvasElement.addEventListener('shown.bs.collapse', function (event) {
            const toggle = offcanvasElement.querySelector('[data-bs-target="#' + event.target.id + '"]');
            if (toggle && typeof toggle.scrollIntoView === 'function') {
                toggle.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });

        offcanvasElement.addEventListener('hidden.bs.offcanvas', function () {
            // Restore scroll position
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            // Restore before Bootstrap returns focus to the sticky menu button;
            // smooth scrolling can be interrupted by that focus change.
            window.scrollTo({ top: scrollY, behavior: 'instant' });

            // Clean up any stuck backdrops
            setTimeout(function () {
                const backdrops = document.querySelectorAll('.offcanvas-backdrop');
                backdrops.forEach(function (backdrop) {
                    backdrop.remove();
                });
            }, 300);
        });
    }
});
